module.exports = __webpack_public_path__ + "img/spirit-tracks.9284eecb.jpg";